"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
function Timeline(_a) {
    var timeline = _a.timeline;
    var partLength = timeline > 3000 ? 600 : timeline >= 1500 ? 180 : timeline >= 1200 ? 180 : timeline >= 600 ? 60 : timeline <= 600 ? 30 : 30;
    // let parts = []
    var _b = react_1.useState([]), parts = _b[0], setParts = _b[1];
    var times = Math.floor(timeline / partLength);
    var arr = [];
    react_1.useEffect(function () {
        //Set parts for timeline
        for (var i = 0; i < times; i++) {
            var newPart = Math.round((timeline + 1) / partLength) * partLength;
            newPart = newPart.toFixed(2);
            if (newPart.length > 6) {
                arr.push(storybook_1.Helpers.toHHMMSS(newPart));
            }
            else {
                arr.push(storybook_1.Helpers.toMinutes(newPart));
            }
            timeline = timeline - partLength;
        }
        setParts(arr.reverse());
    }, []);
    var firstHalf = parts.length / 2;
    return react_1.default.createElement("div", { className: 'storybook-timelines-timeline-container' },
        react_1.default.createElement(storybook_1.Timelines.TrackLegend, null),
        react_1.default.createElement("div", { className: 'storybook-timelines-timeline-body' },
            react_1.default.createElement("div", { className: 'zero' }, "0:00"),
            parts.map(function (part, index) {
                var lastPart = index + 1 === parts.length ? part.length > 6 ? 'last' : 'last small' : '';
                return react_1.default.createElement("div", { className: lastPart, key: index }, part);
            })));
}
exports.default = Timeline;
Timeline.propTypes = {
    /**
     * Timeline for the parts of the video
     */
    timeline: prop_types_1.default.number.isRequired,
};
